import { render, staticRenderFns } from "./AboutUsSection.vue?vue&type=template&id=63560088"
import script from "./AboutUsSection.vue?vue&type=script&lang=js"
export * from "./AboutUsSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports